export const environment = {
    production: false,
    apiUrl: 'https://billing-api.test.i-host.gr/api/v1',
    stripeKey: 'pk_test_Fidch4ykJ4h1t6USttb3F0la00KgBpJpoz'
};